import classNames from 'classnames';
import React from 'react';

import css from './IconBakery.module.css';

const IconBakery = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      version="1.1"
      viewBox="0 0 64 64"
      enableBackground="new 0 0 64 64"
    >
      <path
        d="M29.491 20.519c-.263-.16-.535-.311-.817-.455-1.606-.82-3.4-1.243-5.209-1.462a40.47 40.47 0 0 0-9.941.056c-1.322.174-2.624.47-3.843.99-.606.258-1.175.548-1.708.87-2.544 1.546-3.52 4.356-2.676 6.852.143.425.4.977.725 1.582l-.053 18.245c-.002.673.57 1.22 1.277 1.22h22.973c.706 0 1.278-.547 1.276-1.22l-.052-18.245c.324-.605.581-1.157.724-1.582.845-2.496-.131-5.306-2.676-6.851z"
        fill="#ffffff"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M9.733 28a6.765 6.765 0 0 1-.537-1.779c-.152-1.014.525-1.971 1.573-2.208M9.972 44.338V32.29M38.095 20.048l-6.652 8.904"
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M35.419 13.196c-.264-.159-.536-.31-.817-.454-1.603-.82-3.387-1.24-5.183-1.46a40.471 40.471 0 0 0-9.915.047c-1.346.175-2.672.473-3.916 1.005l-.036.016c-1.048.452-1.983 1.117-2.814 1.887-1.96 1.812-5.834 5.678-7.235 9.061a6.168 6.168 0 0 1 2.47-2.78 13.568 13.568 0 0 1 1.708-.87c1.219-.52 2.52-.816 3.843-.99a40.468 40.468 0 0 1 9.941-.056c1.808.22 3.603.642 5.21 1.462.28.144.553.295.816.455 2.545 1.545 3.52 4.355 2.676 6.85-.143.426-.4.978-.724 1.583l.052 18.245c0 .176-.041.341-.112.492l6.529-7.684c.141-.182.218-.405.218-.634V19.94c.78-2.469-.203-5.22-2.711-6.743z"
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M19.011 53h34.65c2.832 0 5.312-2.099 5.339-4.796v-.052c0-5.999-10.146-10.859-22.67-10.859-12.512 0-22.658 4.86-22.658 10.859v.052c.026 2.697 2.507 4.796 5.34 4.796z"
        fill="#ffffff"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M23.918 42.402s1.008-2.264 4.02-4.386M31.325 42.402s1.257-2.821 5.13-5.109M38.732 42.402s1.071-2.418 4.32-4.587M46.14 42.402s.684-1.54 2.614-3.271"
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default IconBakery;
